/* eslint-disable @typescript-eslint/no-use-before-define */
import { SortGroupType, } from '../models/YearlyTableData';
import { Direction, SortTypes } from '../types';
import { compareByRows, compareRowsBySortField } from '../utils';
var useYearlyTableData = function (tableData, sortType, direction) {
    var data;
    if (!tableData)
        return undefined;
    switch (sortType) {
        case SortTypes.Grade:
            data = tableData.get(SortGroupType.Grade);
            break;
        case SortTypes.Time:
            data = tableData.get(SortGroupType.Time);
            break;
        case SortTypes.Student:
            data = tableData.get(SortGroupType.None);
            break;
        case SortTypes.PT:
        default:
            data = tableData.get(SortGroupType.Level);
            break;
    }
    if (sortType === SortTypes.Student) {
        data === null || data === void 0 ? void 0 : data.groupedData.forEach(function (g) {
            return g.rows.sort(function (a, b) { return compareByRows(a, b, direction); });
        });
    }
    else {
        data === null || data === void 0 ? void 0 : data.groupedData.sort(function (a, b) { return compare(a, b, direction); });
        data === null || data === void 0 ? void 0 : data.groupedData.forEach(function (g) {
            return g.rows.sort(function (a, b) { return compareRowsBySortField(a, b, direction); });
        });
    }
    return data;
};
var compare = function (a, b, direction) {
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.group.sort < b.group.sort) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.group.sort > b.group.sort) {
        return 1 * d;
    }
    return 0;
};
export { useYearlyTableData };
